export default __webpack_public_path__ + "static/media/network_single_ip_24.3fc5f38b.svg";